import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'money'})
export class MoneyPipe implements PipeTransform  {
  transform(value: any): string {
    if (!value) {
       value = "0";
    }

    return String(value).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/money.pipe.ts